var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgTr = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1200 800"
}, props), /* @__PURE__ */ React.createElement("path", {
  fill: "#e30a17",
  d: "M0 0h1200v800H0z"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 425,
  cy: 400,
  r: 200,
  fill: "#fff"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 475,
  cy: 400,
  r: 160,
  fill: "#e30a17"
}), /* @__PURE__ */ React.createElement("path", {
  fill: "#fff",
  d: "m583.334 400 180.901 58.779-111.804-153.885v190.212l111.804-153.885z"
}));
export { SvgTr as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDgwMCI+PHBhdGggZmlsbD0iI2UzMGExNyIgZD0iTTAgMGgxMjAwdjgwMEgweiIvPjxjaXJjbGUgY3g9IjQyNSIgY3k9IjQwMCIgcj0iMjAwIiBmaWxsPSIjZmZmIi8+PGNpcmNsZSBjeD0iNDc1IiBjeT0iNDAwIiByPSIxNjAiIGZpbGw9IiNlMzBhMTciLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJtNTgzLjMzNCA0MDAgMTgwLjkwMSA1OC43NzktMTExLjgwNC0xNTMuODg1djE5MC4yMTJsMTExLjgwNC0xNTMuODg1eiIvPjwvc3ZnPg==";
